import { createBrowserRouter, Navigate } from "react-router-dom";
import BaseLayout from "../layouts/base";
import MainPage from "../pages/main";
import Applications from "../pages/applications";
import QNAPage from "../pages/qna";
import Login from "../pages/login";
import AdminMain from "../pages/adminMain";
import ManageRequests from "../pages/manageRequests";
import AdminSettings from "../pages/adminSettings";
import { useAuth } from "../auth";
// Компонент защиты маршрута
const ProtectedRoute = ({ element }) => {
  const { isAdmin } = useAuth();
  return isAdmin ? element : <Login />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <BaseLayout />,
    children: [
      {
        path: "/",
        element: <MainPage />,
      },
      {
        path: "applications",
        element: <Applications />,
      },
      {
        path: "qna",
        element: <QNAPage />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "adminMain",
        element: <ProtectedRoute element={<AdminMain />} />,
      },
      {
        path: "manage-requests",
        element: <ProtectedRoute element={<ManageRequests />} />,
      },
      {
        path: "admin-settings",
        element: <ProtectedRoute element={<AdminSettings />} />,
      },
    ],
  },
]);

export default router;
